module.exports = __webpack_public_path__ + "static/img/App item-1.c6a843d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item-1.png
// module id = +IKm
// module chunks = 12